import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['trigger'];

  declare triggerTargets: HTMLElement[];

  initialize() {
    for (const element of this.triggerTargets) {
      element.removeAttribute('hidden');
    }
  }

  dismiss() {
    this.element.remove();
  }
}
